import forge from 'node-forge';
import { TimeManagerService } from './TimeManagerService';

export default class FormPasswordManager {
    constructor() {
        this.public_key = window.imaios.get('public_encryption');
        this.paswordArrayForm = [
            "formlogin[password]",
            "formregister[password]",
            "shopuser[password][first]",
            "shopuser[password][second]", // confirmation
            "accountprofilesecurity[oldPassword]",
            "accountprofilesecurity[password][first]",
            "accountprofilesecurity[password][second]", // confirmation
            "formresetpassword[password][first]",
            "formresetpassword[password][second]",
            "_password" // ibexa admin login form
        ];
    }

    canEncrypt(key) {
        return this.public_key && this.paswordArrayForm.includes(key);
    }

    async encrypt(message, key) {
        if (!this.canEncrypt(key)) {
            return false;
        }

        const singleton = await TimeManagerService.getInstance();
        let serverTime = singleton.getTime()

        const publicKey = forge.pki.publicKeyFromPem(
            `-----BEGIN PUBLIC KEY-----` + this.public_key + `-----END PUBLIC KEY-----`
        );

        const utf8Message = forge.util.encodeUtf8(message + serverTime);
        const encrypted = publicKey.encrypt(utf8Message, 'RSAES-PKCS1-V1_5');
        return forge.util.encode64(encrypted);
    }
}
